// AppRouter.jsx
import {
    BrowserRouter as Router,
    Link,
    Navigate,
    Route,
    Routes,
} from "react-router-dom";
import ReactGA from "react-ga4";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import LandingScreen from "../pages/LandingScreen";
import PCQRLibroScreen from "../pages/PCQRLibroScreen";
import PocketCardScreen from "../pages/Books/PocketCardScreen";
import ComposicionSMScreen from "../pages/Books/ComposicionSMScreen";
import MagiaScreen from "../pages/MagiaScreen";
import Navbar from "../components/Navbar";
import ExplicacionScreen from "../pages/ExplicacionScreen";
import CJEAsistencia from "../pages/CJEAsistencia";
import NodosScreen from "../pages/NodosScreen";
import NamesScreen from "../pages/NamesScreen";
import LibrosScreen from "../pages/LibrosScreen";
import LaCuentaScreen from "../pages/LaCuentaScreen";
import RadicalScreen from "../pages/RadicalScreen";
import RadicalScreenVideos from "../pages/RadicalScreenVideos";
import PisosScreen from "../pages/PisosScreen";
import { Button, Container, Typography } from "@mui/material";
import RaisonDEtre from "../pages/RaisonDEtre";
import StopwatchScreen from "../pages/StopwatchScreen";
import CardDetectorScreen from "../pages/CardDetectorScreen";
import LieToMeScreen from "../pages/LieToMeScreen";
// import FoldAndCutScreen from "../pages/FoldAndCutScreen";

const Analytics = () => {
    const location = useLocation();

    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: location.pathname + location.search,
        });
    }, [location]);

    return null;
};

const routes = [
    {
        path: "/",
        screen: Capacitor.isNativePlatform() ? (
            <Navigate to="/herramientas" replace />
        ) : (
            <LandingScreen />
        ),
    },
    { path: "/magia", screen: <MagiaScreen /> },
    { path: "/magia/composicionsm", screen: <ComposicionSMScreen /> },
    { path: "/magia/pocketcard", screen: <PocketCardScreen /> },
    { path: "/magia/pocketcard/qrlibro", screen: <PCQRLibroScreen /> },
    {
        path: "/magia/pocketcard/fotofantasma",
        screen: <ExplicacionScreen juego="fotoFanstasma" />,
    },
    {
        path: "/magia/pocketcard/teladepasta",
        screen: <ExplicacionScreen juego="telaDePasta" />,
    },
    { path: "/cje/asistencia", screen: <CJEAsistencia /> },
    { path: "/nodos", screen: <NodosScreen /> },
    { path: "/nombres", screen: <NamesScreen /> },
    { path: "/libros", screen: <LibrosScreen /> },
    { path: "/tools/cuenta", screen: <LaCuentaScreen /> },
    { path: "/tools/pisos", screen: <PisosScreen /> },
    { path: "/tools/radical", screen: <RadicalScreen /> },
    { path: "/tools/radical/videos", screen: <RadicalScreenVideos /> },
    { path: "/tools/raison", screen: <RaisonDEtre /> },
    { path: "/tools/lie", screen: <LieToMeScreen /> },
    // { path: "/tools/foldandcut", screen: <FoldAndCutScreen /> },
    { path: "/tools/crono", screen: <StopwatchScreen /> },
    { path: "/tools/yolo", screen: <CardDetectorScreen /> },
];

const HerramientasScreen = () => {
    return (
        <Container style={{ padding: "24px" }}>
            <Typography variant="h4">Herramientas</Typography>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                }}
            >
                {routes.map(({ path }) => (
                    <Link key={path} to={path}>
                        <Button variant="contained">{path}</Button>
                    </Link>
                ))}
            </div>
        </Container>
    );
};

const AppRouter = () => {
    return (
        <Router>
            <Analytics />
            <Navbar />
            <Routes>
                {routes.map(({ path, screen }) => (
                    <Route key={path} exact path={path} element={screen} />
                ))}

                <Route
                    exact
                    path="/herramientas"
                    element={<HerramientasScreen />}
                />
            </Routes>
        </Router>
    );
};

export default AppRouter;
